import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Collapse } from 'reactstrap';

import Icon, { faChevronDown, faChevronUp, faCircleExclamation } from '~components/icon';
import { Column, TableView } from '~components/table-view';

import { ErrorItem } from '~support-at-home/actions/statements';

interface ComponentProps {
  id: string;
  title: string;
  errors: ErrorItem[];
  columns: Column[];
  /** Start expanded. Used where the errors are the whole answer (TAV-3491 rollback check). */
  defaultOpen?: boolean;
}

const ErrorDetailsCard: React.FC<ComponentProps> = ({ id, title, errors, columns, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Card className="rounded-0">
      <CardHeader
        className="d-flex justify-content-between border-0 fw-bold align-items-center"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div>
          <Icon icon={faCircleExclamation} className="text-danger me-2" />
          {title} ({errors.length})
        </div>
        <Icon icon={isOpen ? faChevronUp : faChevronDown} className="ms-2" />
      </CardHeader>
      <Collapse isOpen={isOpen}>
        <CardBody className="p-0">
          <TableView
            id={`${id}-error-table`}
            columns={columns}
            data={errors}
            emptyMessage="No errors to display"
            readonly
            striped
          />
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default ErrorDetailsCard;
